'use strict';
const angular = require('angular');
import ConfigurationsController from './configurations.controller';

export default angular.module('nomasvelloDashboardApp.configurations', [])
    .controller('ConfigurationsController', ConfigurationsController)
    .name;



// WEBPACK FOOTER //
// ./client/app/admin/configurations/index.ts